module.exports = __webpack_public_path__ + "bootstrap-material-design.min.css";